import { ReactElement } from 'react';

import {
   IconFillColor,
   IconSize,
   IconWrapper,
   ReservationApprovedIcon,
   ReservationNotApprovedIcon,
} from '@dreryk/react-components';

type AppointmentsTimetableEventAppointmentConfirmationStatusIconProps = {
   confirmed: boolean;
};

export const AppointmentsTimetableEventAppointmentConfirmationStatusIcon = (
   props: AppointmentsTimetableEventAppointmentConfirmationStatusIconProps
): ReactElement => {
   return (
      <IconWrapper
         testId={'appointmentConfirmationStatus'}
         fillColor={props.confirmed ? IconFillColor.SUCCESS : IconFillColor.BACKGROUND}
         size={IconSize.SMALLEST}
      >
         {props.confirmed ? <ReservationApprovedIcon /> : <ReservationNotApprovedIcon />}
      </IconWrapper>
   );
};
